/* eslint-disable lines-around-comment */
import React from 'react';
import { makeStyles } from 'tss-react/mui';
// @ts-ignore
import { AccountSettingTopView } from './AccountSettingTopView';
import { getConferenceName } from '../../../conference/functions';
import { PREMEETING_BUTTONS, THIRD_PARTY_PREJOIN_BUTTONS } from '../../../config/constants';
import { getToolbarButtons, isToolbarButtonEnabled } from '../../../config/functions.web';
import { connect } from '../../../redux/functions';
import { withPixelLineHeight } from '../../../styles/functions.web';
// @ts-ignore
import Footer from "./Footer";
import ConnectionStatus from './ConnectionStatus';
// @ts-ignore
import Preview from './Preview';
const useStyles = makeStyles()(theme => {
    return {
        subtitle: Object.assign(Object.assign({}, withPixelLineHeight(theme.typography.heading5)), { color: theme.palette.text01, marginBottom: theme.spacing(4), overflow: 'hidden', textAlign: 'center', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '100%' })
    };
});
const PreMeetingScreen = ({ _buttons, _premeetingBackground, _roomName, children, className, showDeviceStatus, skipPrejoinButton, title, videoMuted, videoTrack, showJoinActions, user, avatarUrl }) => {
    const { classes } = useStyles();
    const containerClassName = `premeeting-screen ${className ? className : ''}`;
    const style = _premeetingBackground ? {
        background: _premeetingBackground,
        backgroundPosition: 'center',
        backgroundSize: 'cover'
    } : {};
    return (React.createElement("div", { className: 'premeeting-screen', id: 'lobby-screen', style: {
            height: '100%',
            overflow: 'hidden'
        } },
        React.createElement(ConnectionStatus, null),
        React.createElement(Preview, { videoMuted: videoMuted, videoTrack: videoTrack, showJoinActions: showJoinActions }),
        React.createElement("div", { className: 'content', style: { overflow: 'auto' } },
            React.createElement("div", { className: 'content-body', style: {
                    padding: '13px 8px 13px 8px',
                    height: '50px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                } },
                React.createElement(AccountSettingTopView, { user: user, avatarUrl: avatarUrl, show: undefined, isMod: undefined, displayName: undefined, isConference: undefined, handleLogout: undefined })),
            React.createElement("div", { style: {
                    flex: 1,
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                } },
                React.createElement("div", { className: 'content-body p-10 mb-400' }, children)),
            React.createElement("div", { className: "footer-welcome-screen z-index-1" },
                React.createElement(Footer, null)))));
};
/**
 * Maps (parts of) the redux state to the React {@code Component} props.
 *
 * @param {Object} state - The redux state.
 * @param {Object} ownProps - The props passed to the component.
 * @returns {Object}
 */
function mapStateToProps(state, ownProps) {
    const { hiddenPremeetingButtons, hideConferenceSubject } = state['features/base/config'];
    const toolbarButtons = getToolbarButtons(state);
    const premeetingButtons = (ownProps.thirdParty
        ? THIRD_PARTY_PREJOIN_BUTTONS
        : PREMEETING_BUTTONS).filter((b) => !(hiddenPremeetingButtons || []).includes(b));
    const { premeetingBackground } = state['features/dynamic-branding'];
    return {
        // For keeping backwards compat.: if we pass an empty hiddenPremeetingButtons
        // array through external api, we have all prejoin buttons present on premeeting
        // screen regardless of passed values into toolbarButtons config overwrite.
        // If hiddenPremeetingButtons is missing, we hide the buttons according to
        // toolbarButtons config overwrite.
        _buttons: hiddenPremeetingButtons
            ? premeetingButtons
            : premeetingButtons.filter(b => isToolbarButtonEnabled(b, toolbarButtons)),
        _premeetingBackground: premeetingBackground,
        _roomName: hideConferenceSubject ? undefined : getConferenceName(state)
    };
}
export default connect(mapStateToProps)(PreMeetingScreen);
